export const normalizeHhStoredSpecializationList = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value.map(String).map((item) => item.trim()).filter(Boolean);
  }

  if (typeof value === 'string' && value.trim()) {
    return value.split(',').map((item) => item.trim()).filter(Boolean).map(String);
  }

  return [];
};

export const isSameHhStoredSpecializationSelection = (
  currentValue: unknown,
  cachedValue: unknown,
): boolean => {
  const current = normalizeHhStoredSpecializationList(currentValue);
  const cached = normalizeHhStoredSpecializationList(cachedValue);

  if (current.length === 0 || cached.length === 0 || current.length !== cached.length) {
    return false;
  }

  const currentSet = new Set(current);
  const cachedSet = new Set(cached);

  if (currentSet.size !== cachedSet.size) {
    return false;
  }

  return Array.from(currentSet).every((item) => cachedSet.has(item));
};
